import { Subject, merge } from 'rxjs'
import { distinctUntilChanged, filter, map, mapTo } from 'rxjs/operators'

export const rxOpenAlert = new Subject()
export const rxOpenConfirm = new Subject()
export const rxOpenPrompt = new Subject()

export const rxEnterRoom = new Subject()

export const rxJoin = new Subject()
export const rxLeave = new Subject()

export const rxOpenTag = new Subject()
export const rxOpenRule = new Subject()
export const rxOpenPlaySetting = new Subject()
export const rxOpenSetting = new Subject()
export const rxOpenClear = new Subject()

export const rxSound = new Subject()
export const rxChat = new Subject()

export const rxGamepadButtons = [
  new Subject(), new Subject(), new Subject(), new Subject(),
  new Subject(), new Subject(), new Subject(), new Subject()
]
export const rxGamepadAxes = [
  new Subject(), new Subject()
]
export const rxGamepad = merge(
  ...rxGamepadButtons.map((rx, index) => (
    rx.pipe(
      distinctUntilChanged(),
      filter(value => value),
      mapTo(index)
    )
  )),
  ...rxGamepadAxes.map((rx, index) => (
    rx.pipe(
      map(value => Math.abs(value) < 0.7 ? 0 : Math.sign(value)),
      distinctUntilChanged(),
      filter(value => value !== 0),
      map(value => (value + 1) / 2 + index * 2 + rxGamepadButtons.length)
    )
  ))
)
